import React from 'react';
import PropTypes from 'prop-types';

import { LanguageProvider } from '@sopranodesign/pulse-volt';
import { useComposer } from '@sopranodesign/pulse-composer';

const SharedWidgetLanguageProvider = ({ children, languages }) => {
  const { language } = useComposer();

  const current = languages.find(l => l.id === language?.id);

  if (!current) {
    return null;
  }

  return (
    <LanguageProvider
      key={current.id}
      initialLanguage={current}
      namespaces={['bots', 'embed']}
    >
      {children}
    </LanguageProvider>
  );
};

SharedWidgetLanguageProvider.propTypes = {
  languages: PropTypes.array.isRequired
};

export default SharedWidgetLanguageProvider;